/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminMerchantsGetAdminMerchantsParams,
  CreateMerchantRequest,
  HttpValidationProblemDetails,
  MerchantDetailDto,
  MerchantSummaryDto,
  PagedResultOfMerchantSummaryWithClientDto,
  SetMerchantAdyenApiKeyRequest,
  SetMerchantCapabilityGatesRequest,
  SetMerchantLiveUrlPrefixRequest,
  UpdateMerchantRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List merchants for a client.
 */
export const adminMerchantsGetAdminClientsClientIdGuidMerchants = (
  clientId: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantSummaryDto[]>(
    { url: `/admin/clients/${clientId}/merchants`, method: 'GET', signal },
    options,
  );
};

export const getAdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryKey = (
  clientId?: string,
) => {
  return [`/admin/clients/${clientId}/merchants`] as const;
};

export const getAdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryKey(clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>
  > = ({ signal }) =>
    adminMerchantsGetAdminClientsClientIdGuidMerchants(clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!clientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>
>;
export type AdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryError = unknown;

export function useAdminMerchantsGetAdminClientsClientIdGuidMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminClientsClientIdGuidMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminClientsClientIdGuidMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List merchants for a client.
 */

export function useAdminMerchantsGetAdminClientsClientIdGuidMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminClientsClientIdGuidMerchants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminMerchantsGetAdminClientsClientIdGuidMerchantsQueryOptions(
    clientId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a merchant under a client.
 */
export const adminMerchantsPostAdminClientsClientIdGuidMerchants = (
  clientId: string,
  createMerchantRequest: CreateMerchantRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/admin/clients/${clientId}/merchants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMerchantRequest,
      signal,
    },
    options,
  );
};

export const getAdminMerchantsPostAdminClientsClientIdGuidMerchantsMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>,
    TError,
    { clientId: string; data: CreateMerchantRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>,
  TError,
  { clientId: string; data: CreateMerchantRequest },
  TContext
> => {
  const mutationKey = ['adminMerchantsPostAdminClientsClientIdGuidMerchants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>,
    { clientId: string; data: CreateMerchantRequest }
  > = (props) => {
    const { clientId, data } = props ?? {};

    return adminMerchantsPostAdminClientsClientIdGuidMerchants(clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPostAdminClientsClientIdGuidMerchantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>
>;
export type AdminMerchantsPostAdminClientsClientIdGuidMerchantsMutationBody = CreateMerchantRequest;
export type AdminMerchantsPostAdminClientsClientIdGuidMerchantsMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Create a merchant under a client.
 */
export const useAdminMerchantsPostAdminClientsClientIdGuidMerchants = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>,
      TError,
      { clientId: string; data: CreateMerchantRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPostAdminClientsClientIdGuidMerchants>>,
  TError,
  { clientId: string; data: CreateMerchantRequest },
  TContext
> => {
  const mutationOptions =
    getAdminMerchantsPostAdminClientsClientIdGuidMerchantsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Paginated list of all merchants across every client.
 */
export const adminMerchantsGetAdminMerchants = (
  params?: AdminMerchantsGetAdminMerchantsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfMerchantSummaryWithClientDto>(
    { url: `/admin/merchants`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminMerchantsGetAdminMerchantsQueryKey = (
  params?: AdminMerchantsGetAdminMerchantsParams,
) => {
  return [`/admin/merchants`, ...(params ? [params] : [])] as const;
};

export const getAdminMerchantsGetAdminMerchantsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
  TError = unknown,
>(
  params?: AdminMerchantsGetAdminMerchantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMerchantsGetAdminMerchantsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>> = ({
    signal,
  }) => adminMerchantsGetAdminMerchants(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMerchantsGetAdminMerchantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>
>;
export type AdminMerchantsGetAdminMerchantsQueryError = unknown;

export function useAdminMerchantsGetAdminMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
  TError = unknown,
>(
  params: undefined | AdminMerchantsGetAdminMerchantsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
  TError = unknown,
>(
  params?: AdminMerchantsGetAdminMerchantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
  TError = unknown,
>(
  params?: AdminMerchantsGetAdminMerchantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Paginated list of all merchants across every client.
 */

export function useAdminMerchantsGetAdminMerchants<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>,
  TError = unknown,
>(
  params?: AdminMerchantsGetAdminMerchantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminMerchantsGetAdminMerchants>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminMerchantsGetAdminMerchantsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminMerchantsGetAdminMerchantsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/admin/merchants/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdminMerchantsGetAdminMerchantsIdGuidQueryKey = (id?: string) => {
  return [`/admin/merchants/${id}`] as const;
};

export const getAdminMerchantsGetAdminMerchantsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMerchantsGetAdminMerchantsIdGuidQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>
  > = ({ signal }) => adminMerchantsGetAdminMerchantsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMerchantsGetAdminMerchantsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>
>;
export type AdminMerchantsGetAdminMerchantsIdGuidQueryError = unknown;

export function useAdminMerchantsGetAdminMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMerchantsGetAdminMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminMerchantsGetAdminMerchantsIdGuid<
  TData = Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminMerchantsGetAdminMerchantsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminMerchantsGetAdminMerchantsIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminMerchantsPutAdminMerchantsIdGuid = (
  id: string,
  updateMerchantRequest: UpdateMerchantRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/admin/merchants/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMerchantRequest,
    },
    options,
  );
};

export const getAdminMerchantsPutAdminMerchantsIdGuidMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>,
    TError,
    { id: string; data: UpdateMerchantRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>,
  TError,
  { id: string; data: UpdateMerchantRequest },
  TContext
> => {
  const mutationKey = ['adminMerchantsPutAdminMerchantsIdGuid'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>,
    { id: string; data: UpdateMerchantRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMerchantsPutAdminMerchantsIdGuid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPutAdminMerchantsIdGuidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>
>;
export type AdminMerchantsPutAdminMerchantsIdGuidMutationBody = UpdateMerchantRequest;
export type AdminMerchantsPutAdminMerchantsIdGuidMutationError = HttpValidationProblemDetails;

export const useAdminMerchantsPutAdminMerchantsIdGuid = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>,
      TError,
      { id: string; data: UpdateMerchantRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuid>>,
  TError,
  { id: string; data: UpdateMerchantRequest },
  TContext
> => {
  const mutationOptions = getAdminMerchantsPutAdminMerchantsIdGuidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminMerchantsPostAdminMerchantsIdGuidSuspend = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/admin/merchants/${id}/suspend`, method: 'POST', signal },
    options,
  );
};

export const getAdminMerchantsPostAdminMerchantsIdGuidSuspendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminMerchantsPostAdminMerchantsIdGuidSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminMerchantsPostAdminMerchantsIdGuidSuspend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPostAdminMerchantsIdGuidSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>
>;

export type AdminMerchantsPostAdminMerchantsIdGuidSuspendMutationError = unknown;

export const useAdminMerchantsPostAdminMerchantsIdGuidSuspend = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidSuspend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminMerchantsPostAdminMerchantsIdGuidSuspendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const adminMerchantsPostAdminMerchantsIdGuidActivate = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/admin/merchants/${id}/activate`, method: 'POST', signal },
    options,
  );
};

export const getAdminMerchantsPostAdminMerchantsIdGuidActivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminMerchantsPostAdminMerchantsIdGuidActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminMerchantsPostAdminMerchantsIdGuidActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPostAdminMerchantsIdGuidActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>
>;

export type AdminMerchantsPostAdminMerchantsIdGuidActivateMutationError = unknown;

export const useAdminMerchantsPostAdminMerchantsIdGuidActivate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPostAdminMerchantsIdGuidActivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminMerchantsPostAdminMerchantsIdGuidActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set or rotate the per-merchant Adyen API key (SuperAdmin only).
 */
export const adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey = (
  id: string,
  setMerchantAdyenApiKeyRequest: SetMerchantAdyenApiKeyRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/admin/merchants/${id}/adyen-api-key`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setMerchantAdyenApiKeyRequest,
    },
    options,
  );
};

export const getAdminMerchantsPutAdminMerchantsIdGuidAdyenApiKeyMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>,
    TError,
    { id: string; data: SetMerchantAdyenApiKeyRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>,
  TError,
  { id: string; data: SetMerchantAdyenApiKeyRequest },
  TContext
> => {
  const mutationKey = ['adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>,
    { id: string; data: SetMerchantAdyenApiKeyRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPutAdminMerchantsIdGuidAdyenApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>
>;
export type AdminMerchantsPutAdminMerchantsIdGuidAdyenApiKeyMutationBody =
  SetMerchantAdyenApiKeyRequest;
export type AdminMerchantsPutAdminMerchantsIdGuidAdyenApiKeyMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Set or rotate the per-merchant Adyen API key (SuperAdmin only).
 */
export const useAdminMerchantsPutAdminMerchantsIdGuidAdyenApiKey = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>,
      TError,
      { id: string; data: SetMerchantAdyenApiKeyRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidAdyenApiKey>>,
  TError,
  { id: string; data: SetMerchantAdyenApiKeyRequest },
  TContext
> => {
  const mutationOptions =
    getAdminMerchantsPutAdminMerchantsIdGuidAdyenApiKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clear the per-merchant Adyen API key override; falls back to client/global key.
 */
export const adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    { url: `/admin/merchants/${id}/adyen-api-key`, method: 'DELETE' },
    options,
  );
};

export const getAdminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>
>;

export type AdminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKeyMutationError = unknown;

/**
 * @summary Clear the per-merchant Adyen API key override; falls back to client/global key.
 */
export const useAdminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKey>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getAdminMerchantsDeleteAdminMerchantsIdGuidAdyenApiKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set or clear the Adyen live merchant URL prefix.
 */
export const adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix = (
  id: string,
  setMerchantLiveUrlPrefixRequest: SetMerchantLiveUrlPrefixRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/admin/merchants/${id}/live-url-prefix`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setMerchantLiveUrlPrefixRequest,
    },
    options,
  );
};

export const getAdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefixMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>,
    TError,
    { id: string; data: SetMerchantLiveUrlPrefixRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>,
  TError,
  { id: string; data: SetMerchantLiveUrlPrefixRequest },
  TContext
> => {
  const mutationKey = ['adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>,
    { id: string; data: SetMerchantLiveUrlPrefixRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefixMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>
>;
export type AdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefixMutationBody =
  SetMerchantLiveUrlPrefixRequest;
export type AdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefixMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Set or clear the Adyen live merchant URL prefix.
 */
export const useAdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>,
      TError,
      { id: string; data: SetMerchantLiveUrlPrefixRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefix>>,
  TError,
  { id: string; data: SetMerchantLiveUrlPrefixRequest },
  TContext
> => {
  const mutationOptions =
    getAdminMerchantsPutAdminMerchantsIdGuidLiveUrlPrefixMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set per-merchant currency / payment-method / amount allowlists.
 */
export const adminMerchantsPutAdminMerchantsIdGuidCapabilityGates = (
  id: string,
  setMerchantCapabilityGatesRequest: SetMerchantCapabilityGatesRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<MerchantDetailDto>(
    {
      url: `/admin/merchants/${id}/capability-gates`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setMerchantCapabilityGatesRequest,
    },
    options,
  );
};

export const getAdminMerchantsPutAdminMerchantsIdGuidCapabilityGatesMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>,
    TError,
    { id: string; data: SetMerchantCapabilityGatesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>,
  TError,
  { id: string; data: SetMerchantCapabilityGatesRequest },
  TContext
> => {
  const mutationKey = ['adminMerchantsPutAdminMerchantsIdGuidCapabilityGates'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>,
    { id: string; data: SetMerchantCapabilityGatesRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMerchantsPutAdminMerchantsIdGuidCapabilityGates(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMerchantsPutAdminMerchantsIdGuidCapabilityGatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>
>;
export type AdminMerchantsPutAdminMerchantsIdGuidCapabilityGatesMutationBody =
  SetMerchantCapabilityGatesRequest;
export type AdminMerchantsPutAdminMerchantsIdGuidCapabilityGatesMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Set per-merchant currency / payment-method / amount allowlists.
 */
export const useAdminMerchantsPutAdminMerchantsIdGuidCapabilityGates = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>,
      TError,
      { id: string; data: SetMerchantCapabilityGatesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminMerchantsPutAdminMerchantsIdGuidCapabilityGates>>,
  TError,
  { id: string; data: SetMerchantCapabilityGatesRequest },
  TContext
> => {
  const mutationOptions =
    getAdminMerchantsPutAdminMerchantsIdGuidCapabilityGatesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
